






























































































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import {GCICategoryListRes} from '@/model/dto/res/contents/get-category-list-res';
import {PUUDataReq, PostUpsertUserReq} from '@/model/dto/req/user/post-upsert-user-req';
import {GlobalConstants} from '@/common/constants';
import {GlobalAuthority, AuthorityNum} from '@/common/authority';
import _ from 'lodash';

@Component({
  components: {
  }
})
export default class UsersForm extends Vue {
  /** Data **/
  private valid: boolean = true;
  private index: number = 0;
  private id: number = 1;
  private select: number | null = null;

  private rules = {
    required: (v: string) => !!v || this.text.required,
    min: (v: string) => v.length >= this.text.minValue || this.text.minText,
    max: (v: string) => v.length <= this.text.maxValue || this.text.maxText,
    nameRules: [
      (v: string) => !!v || 'Name is required',
      (v: string) => (v && v.length <= 50) || 'Name must be less than 10 characters',
    ],
    emailRules: [
      (v: string) => !!v || 'E-mail is required',
      (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ]
  };
  public $refs!: {
    form: HTMLElement
  };
  /** Computed **/
  set name(val: any) {
    userModule.updateSelectUserInfoName(val);
  }

  get name() {
    return userModule.selectUserInfo.user_name;
  }

  set type(val: any) {
    userModule.updateSelectUserInfoType(val);
  }

  get type() {
    return userModule.selectUserInfo.type ?? 'Instructor';
  }

  set mail(val: any) {
    userModule.updateSelectUserInfoMail(val);
  }

  get mail() {
    return userModule.selectUserInfo.email;
  }

  set password(val: any) {
    userModule.updateSelectUserInfoPassword(val);
  }

  get password() {
    return userModule.selectUserInfo.password;
  }

  get userId() {
    return userModule.selectUserInfo.user_id;
  }

  get authority() {
    const arr = [GlobalAuthority.Admin, GlobalAuthority.Instructor, GlobalAuthority.Assistant, GlobalAuthority.Learner];
    const merged = _.flatten(arr);
    return merged;
  }

  get text() {
    return {
      title: GlobalConstants.TEXT.CATEGORYMANAGE.TITLE,
      label: GlobalConstants.TEXT.CATEGORYMANAGE.LABEL,
      key: GlobalConstants.TEXT.CATEGORYMANAGE.KEY,
      minValue: GlobalConstants.TEXT.CATEGORYMANAGE.MIN.VALUE,
      maxValue: GlobalConstants.TEXT.CATEGORYMANAGE.MAX.VALUE,
      minText: GlobalConstants.TEXT.CATEGORYMANAGE.MIN.TEXT,
      maxText: GlobalConstants.TEXT.CATEGORYMANAGE.MAX.TEXT,
      required: GlobalConstants.TEXT.CATEGORYMANAGE.REQUIRED,
      uniq: GlobalConstants.TEXT.CATEGORYMANAGE.UNIQ,
      regex: GlobalConstants.TEXT.CATEGORYMANAGE.REGEX,
      saveConfirmation: GlobalConstants.TEXT.CATEGORYMANAGE.SAVECONFIRMATION,
      allow: GlobalConstants.TEXT.ARROW,
      aconfirmation: GlobalConstants.TEXT.ALLOWCONFIRMATION,
    };
  }

  /** Watch **/
  /** Methods **/
  private resetValidation() {
  //  this.$refs.form.resetValidation(); requestInfomationInfo(1)
  }

  private async validate() {
    const params: PUUDataReq = {
      id: this.userId,
      name: this.name,
      type: this.type,
      password: this.password,
      email: this.mail
    };
    await appModule.updateIsConfirmationDialog({
      type: 'usersSave',
      state: true,
      title: `${this.text.allow}`,
      message: `${this.text.aconfirmation}`,
      data: params
    });

  }

  private reset() {
    this.$nextTick(() => {
      const { form }: any = this.$refs;
      if (!form) { return; }
      form.reset();
    });
  }
  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

}
